import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import Icons from '../../assets/icons'
import { CARD_TITLE, COMMISSION_MODAL } from './reports.constants'

import { useSelector, useDispatch } from 'react-redux'
import { selectFilters } from './reports.selectors'
import {
	setSelectedAdditionalDataModal,
	setAdditionalModal,
	setCommissionsAdditionalType,
} from './reports.slice'
import classNames from 'classnames'
import {
	fetchCommissionsAdditional,
	fetchTotalsAdditional,
} from './reports.asynActions'
import { isEmpty } from 'lodash'
import { ArrowDown, ArrowUp } from 'lucide-react'
import StatsCard from '../../components/cards/StatsCard'

const CustomCard = ({ cards, cardTitle }) => {
	const dispatch = useDispatch()
	const filters = useSelector(selectFilters)

	const numberWithCommas = (number) => {
		return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')
	}
	const formattedValue = (isCurrency, currentValue) => {
		if (isCurrency) {
			return `$${numberWithCommas(currentValue && currentValue.toFixed(2))}`
		} else {
			return `${currentValue}`
		}
	}
	const valueDiffrence = (currentValue, previousValue) =>
		currentValue - previousValue

	const changePercentage = (currentValue, previousValue) => {
		if (!previousValue && currentValue) return '100.0'
		else if (previousValue && !currentValue) return '100.0'
		else if (previousValue && currentValue)
			return (
				(Math.abs(currentValue - previousValue) * 100) /
				previousValue
			).toFixed(1)
		else return '0.0'
	}

	const getIcon = (currentValue, previousValue) => {
		if (valueDiffrence(currentValue, previousValue) < 0) {
			return <ArrowDown className='text-red-500 w-4 h-4' />
		} else if (valueDiffrence(currentValue, previousValue) > 0) return <ArrowUp className='text-green-500 w-4 h-4' />
		else if (valueDiffrence(currentValue, previousValue) === 0) return ''
	}
	return (
		<>
			{cards &&
				cards.map((each) => (
					<div key={each.title} className='h-full'>
						<Card
							className='shadow-sm text-center cursor-pointer h-full'
							onClick={() => {
								dispatch(
									setAdditionalModal(
										each.commissionType ? 'Billing' : cardTitle
									)
								)
								dispatch(
									setSelectedAdditionalDataModal(
										each.commissionType
											? COMMISSION_MODAL.COMMISSION_DETAILS
											: each.title
									)
								)
								if (each.currentValue !== 0) {
									if (each.commissionType == null) {
										dispatch(
											fetchTotalsAdditional({
												filters: {
													...filters,
													modalName: each.title,
												},
											})
										)
									} else {
										dispatch(setCommissionsAdditionalType(each.commissionType))
										dispatch(
											fetchCommissionsAdditional({
												filters: {
													...filters,
													commissionType: each.commissionType,
												},
											})
										)
									}
								}
							}}
						>
							<CardContent className='p-3 h-full'>
								<h4 className='text-xs font-semibold mb-2 leading-6'>
									{each.title}
								</h4>
								<h3 className='font-semibold text-2xl leading-7 mb-2'>
									{formattedValue(each.isCurrency, each.currentValue)}
								</h3>
								{isEmpty(each.commissionType) && (
									<span className='text-sm leading-5 font-normal inline-flex items-center'>
										{getIcon(each.currentValue, each.previousValue)}
										<div
											className={classNames('mr-2', {
												'mr-3':
													changePercentage(
														each.currentValue,
														each.previousValue
													) === 0,
											})}
										>
											{`${changePercentage(
												each.currentValue,
												each.previousValue
											)}%`}
										</div>
									</span>
								)}
							</CardContent>
						</Card>
					</div>
				))}
		</>
	)
}

export default CustomCard
